import { render, staticRenderFns } from "./zcqdkc.vue?vue&type=template&id=382db80c&scoped=true&"
import script from "./zcqdkc.vue?vue&type=script&lang=js&"
export * from "./zcqdkc.vue?vue&type=script&lang=js&"
import style0 from "./zcqdkc.vue?vue&type=style&index=0&id=382db80c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382db80c",
  null
  
)

export default component.exports